export default __webpack_public_path__ + "static/13-4a9d85c05885373aa90e2ad4dce36627.jpg";